export const activeFeatures = (hostname: string = window.location.hostname) => {
  return {
    isProduction: hostname === "app.airplx.com",
    isStaging: hostname === "staging.airplx.com",
    isDev: hostname === "localhost",
    isConference: false,
    isMaintenance: false,
    maintenanceEndTime: `March 24 2023 9:15am EST`,
  };
};
